import styled from 'styled-components'
import Colors from 'builder/styles/colors'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'
import Button from 'builder/components/Button'
import { Card } from '../styles'

export const CustomButton = styled(Button)`
  height: 40px;
  gap: 4px;
`

export const Container = styled(Card)<{ $enableHover: boolean }>`
  gap: 0;

  ${({ $enableHover }) =>
    $enableHover &&
    `
        &:hover ${CustomButton} {
          background-color: ${Colors.Blue60};
        }
    `}
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: space-between;
`

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 286px;
  margin-right: 24px;
  ${Media.Phone`
    margin-right: 0;
  `}
`

export const ContainerTooltip = styled.div`
  display: flex;
  margin: auto;
  ${Media.Phone`
    margin: auto 0;
  `}
`

export const ContainerTooltipItems = styled.div`
  display: flex;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  color: ${Colors.Blue50};
  margin-left: 24px;
  height: 22px;
  ${Media.Phone`
    margin-left: 0;
  `}
`

export const Title = styled.div`
  color: ${Colors.Blue80};
  ${Typography.Subhead}
  ${FontWeights.Medium}
  padding-bottom: 3px;
`
export const SubTitle = styled.div`
  color: ${Colors.Blue80};
  ${Typography.Body}
  ${FontWeights.Regular}
`

export const WrapperToggle = styled.div`
  & div {
    margin: 0;
  }
`

export const WrapperNear = styled.span`
  & svg svg * {
    fill: transparent;
    stroke: currentColor;
  }
`

export const Frequency = styled.div`
  color: ${Colors.Blue80};
  ${Typography.Body}
  ${FontWeights.Regular}
  padding: 12px 0 16px;
  ${Media.AbovePhone`
    padding: 12px 0 20px;
  `}

  display: flex;
  gap: 4px;
`
export const TimeIcon = styled.div`
  & svg {
    width: 24px;
    height: 24px;
  }
  & path {
    stroke: ${Colors.Blue80};
  }
`
